module.exports = __webpack_public_path__ + "assets/img/67_319_4.35e9f3fe.jpg";